import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { zIndex } from "src/design-system/styles/zIndices";
import { flexMiddle } from "src/design-system/styles/layout";

type Props = {
  rightSide?: ReactNode;
  leftSide?: ReactNode;
  children: ReactNode;

  backgroundColor?: string;
};

const RightSide = styled.div`
  justify-self: right;
  height: 100%;
  ${flexMiddle}
`;

const LeftSide = styled.div`
  justify-self: left;
  height: 100%;
  ${flexMiddle}
`;

const Header = styled.div<{ backgroundColor: string }>`
  width: 100%;
  box-sizing: border-box;
  z-index: ${zIndex.header};
  background-color: ${({ backgroundColor }) => backgroundColor};

  box-shadow: 1px 2px 6px 0 rgba(0, 0, 0, 0.08), 0 0 4px 1px rgba(0, 0, 0, 0.06);
  height: 45px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 12px;
`;

export default function GenericHeader({
  rightSide,
  leftSide,
  backgroundColor,
  children,
  ...rest
}: Props) {
  return (
    <Header backgroundColor={backgroundColor} {...rest}>
      <LeftSide>{leftSide}</LeftSide>
      {children}
      <RightSide>{rightSide}</RightSide>
    </Header>
  );
}
